import produce from 'immer';
import {
    GET_OVERLAY_CONTENT_FAILED, OVERLAY_LOADED,
} from './constant';
import { IInitialState } from './interface';

/**
 * Export initalState
 *
 * @export initalState
 */
export const initialState: IInitialState = {
    overlayError: false,
    overlayLoaded: false,
};

const overlayReducer = (state = initialState, action) =>
    produce(state, draft => {
        draft.overlayLoaded = initialState.overlayLoaded;
        switch (action.type) {
            case GET_OVERLAY_CONTENT_FAILED:
                draft.overlayError = action.error;
                break;
            case OVERLAY_LOADED:
                draft.overlayLoaded = true;
                break;
        }
    });

export default overlayReducer;
